<template>
    <div style="padding:1px;">
        <v-dialog v-model="dialog" :value="dialog" width="500">
            <template v-slot:activator="{ on, attrs }">
                <v-card elevation="2" v-bind="attrs" v-on="on" rounded class="rounded-card"
                    style="padding:10px;margin-bottom: 6px;" :color="($vuetify.theme.dark) ? 'cardDark' : '#FFFFFF;'">
                    <v-row align="center">
                        <v-col cols="2" style="padding-top:6px; padding-left:10px ;padding-bottom:6px;">
                            <v-avatar style="">
                                <v-icon size="36" :color="selectedColor"> {{ selectedIcon }} </v-icon>
                            </v-avatar>
                        </v-col>

                        <v-col cols="6" v-if="type == 'CHIP' || type == 'CHIP2'" style="padding:6px 0px">
                            <p style="padding-bottom:0px; margin:0px; font-size: medium;" :color="selectedColor"> {{
                                    type
                            }}</p>
                            <p style="margin: 0px; font-size: small;"> {{ site }} </p>
                            <p style="margin: 0px; font-size: small;"> {{ reference }} </p>
                        </v-col>
                        <v-col cols="6" v-if="type != 'CHIP' && type != 'CHIP2'" style="padding:6px 0px;">
                            <p style="margin:0px; font-size: medium" :color="selectedColor"> {{ type }}</p>
                            <p v-if="reftext.length < 1" style="margin:0px; font-size: small"> {{ reference }}</p>
                            <p v-if="reftext.length > 0" style="margin:0px; font-size: small"> {{ reftext }}</p>
                            <p v-if="refDate.length > 0" style="margin:0px; font-size: small"> {{ refDate }}</p>
                            <!-- <p style="margin: 0px; font-size: small"> {{ createdBy }} </p> -->
                        </v-col>

                        <v-col cols="4" style="padding:6px 12px 6px 0px;">
                            <span class="float-right" style=" margin:0px;" v-if="type == 'CHIP' || type == 'CHIP2'">
                                <p style="margin: 0px; font-size: medium; text-align: right;"
                                    :style="{ color: ($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)' }">
                                    £{{ signSwitchedAmount }}</p>
                                <p style=" margin: 0px;font-size: small; text-align: right; color: grey;">
                                    Quantity:&nbsp;{{ quantity }}</p>
                                <p style="margin:0px; font-size: small; text-align: right;"> {{ dateTimeshow }}</p>
                            </span>
                            <span class="float-right" style=" margin:0px;" v-if="type != 'CHIP' && type != 'CHIP2'">
                                <p style="margin: 0px; font-size: medium; text-align: right;"
                                    :style="{ color: ($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)' }">
                                    £{{ signSwitchedAmount }}</p>
                                <p style=" margin: 0px;font-size: small; text-align: right; color: grey;">
                                    Quantity:&nbsp;{{ quantity }}</p>
                                <p style="margin:0px; font-size: small; text-align: right;"> {{ dateTimeshow }}</p>
                            </span>
                        </v-col>
                    </v-row>
                </v-card>
            </template>

            <v-card elevation="3" :class="($vuetify.theme.dark) ? 'dialogDark' : ''">
                <v-card-title class="text-h4"> Transaction</v-card-title>
                <v-card-subtitle class="text-h6" style="padding-bottom:0px;">Ref: {{ reference }}</v-card-subtitle>
                <v-container>


                    <v-card shaped outlined elevation="1">
                        <v-card-text>
                            <v-row>
                                <v-col class="pt-0 pb-0" cols="6"><b>Amount:</b></v-col>
                                <v-col class="pt-0 pb-0" cols="6">
                                    <span :class="($vuetify.theme.dark) ? 'darkPrime' : 'lightPrime'">£{{
                                            signSwitchedAmount
                                    }}</span>
                                </v-col>
                                <v-col class="pt-0 pb-0" cols="6"><b>Site:</b></v-col>
                                <v-col class="pt-0 pb-0" cols="6">{{ site }}</v-col>

                                <v-col class="pt-0 pb-0" cols="6"><b>Created By:</b></v-col>
                                <v-col class="pt-0 pb-0" cols="6">{{ createdBy }}</v-col>

                                <v-col class="pt-0 pb-0" cols="6"><b>Type:</b></v-col>
                                <v-col class="pt-0 pb-0" cols="6">{{ type }}</v-col>

                                <v-col class="pt-0 pb-0" cols="6"><b>Date:</b></v-col>
                                <v-col class="pt-0 pb-0" cols="6">{{ dateTimeshow }}</v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-container>


                <div v-if="linkedTransactions != null">
                    <v-card-subtitle style="padding-top:0px; padding-bottom:0px;" class="text-h6" pb-0
                        v-if="linkedTransactions.length > 0">Linked transactions: </v-card-subtitle>
                    <v-container style="padding-top:0px;">

                        <div v-for="(lt, index) in linkedTransactions" :key="index">
                            <TransactionHolder :accountId="lt.accountId" :amount="lt.amount" :createdBy="lt.createdBy"
                                :fromAccount="lt.fromAccount" :fromLedger="lt.fromLedger" :ledger="lt.ledger"
                                :linkedTxnId="lt.linkedTxnId" :quantity="lt.quantity" :reference="lt.reference"
                                :site="lt.site" :source="lt.source" :transactionDate="lt.transactionDate"
                                :type="lt.type">
                            </TransactionHolder>
                        </div>
                    </v-container>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false"> 
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<style>
p {
    font-size: 16px;
}
</style>
<!-- Display the contents of a single transaction in here  -->
<script>
import moment from 'moment';
export default {
    name: "TransactionHolder",
    components: {
    },
    props: {
        id: Number,
        accountId: Number,
        amount: Number,
        createdBy: String,
        fromAccount: Number,
        fromLedger: String,
        ledger: String,
        linkedTxnId: Number,
        quantity: Number,
        reference: String,
        site: String,
        source: String,
        transactionDate: Number,
        type: String,
        linkedTransactions: Array,
    },
    data: () => ({
        selectedIcon: "mdi-archive-arrow-up",
        selectedColor: "green",
        upIcon: "mdi-archive-arrow-up",
        upColor: "green",
        downIcon: "mdi-archive-arrow-down",
        downColor: "orange",
        outColor: "red",
        dateTimeshow: "",
        dialog: false,
        signSwitchedAmount: undefined,
        reftext: "",
        refDate: "",
    }),
    created: function () {
        if (this.$props.type == 'PAY-OUT')
            this.splitPayoutRef();
        this.formatDate();
        this.assignIcons();
        this.signSwitchedAmount = this.switchSign(this.$props.amount);
    },
    watch: {
        id: function () {

        },
        amount: function () {
            this.signSwitchedAmount = this.switchSign(this.$props.amount);
        },
        createdBy: function () {

        },
        fromAccount: function () {

        },
        fromLedger: function () {

        },
        ledger: function () {

        },
        linkedTxnId: function () {

        },
        quantity: function () {

        },
        reference: function () {

        },
        site: function () {

        },
        source: function () {

        },
        transactionDate: function () {
            this.formatDate();
        },
        type: function () {
            this.assignIcons();
        },
    },
    methods: {
        assignIcons: function () {
            if (this.$props.type == "CHIP") {
                this.selectedIcon = this.upIcon;
                if (this.$vuetify.theme.dark) this.selectedColor = 'var(--successDark)';
                else this.selectedColor = 'var(--successLight)'
            }
            else if (this.$props.type == "CHIP2") {
                this.selectedIcon = this.upIcon;
                if (this.$vuetify.theme.dark) this.selectedColor = 'var(--successDark)';
                else this.selectedColor = 'var(--successLight)'
            }
            else if (this.$props.type == "CHIP-FEE") {
                this.selectedIcon = this.downIcon;
                if (this.$vuetify.theme.dark) this.selectedColor = 'var(--errorDark)';
                else this.selectedColor = 'var(--errorLight)'
            }
            else if (this.$props.type == "PAY-OUT") {
                this.selectedIcon = this.downIcon;
                if (this.$vuetify.theme.dark) this.selectedColor = 'var(--infoDark)';
                else this.selectedColor = 'var(--infoLight)'
            }
            else if (this.$props.type == "PENDING PAYMENT") {
                this.selectedIcon = this.downIcon;
                if (this.$vuetify.theme.dark) this.selectedColor = 'var(--warningDark)';
                else this.selectedColor = 'var(--warningLight)'
            }
            else {
                //Anything else is a fee
                this.selectedIcon = this.downIcon;
                if (this.$vuetify.theme.dark) this.selectedColor = 'var(--errorDark)';
                else this.selectedColor = 'var(--errorLight)'
            }
        },
        formatDate: function () {
            let date = new Date(this.$props.transactionDate);
            let displayDate = date.getMonth() + 1;
            let mins;
            if (date.getMinutes() < 10)
                mins = "0" + date.getMinutes();
            else
                mins = date.getMinutes();
            this.dateTimeshow = date.getDate() + "/" + displayDate + "/" + date.getFullYear() + " (" + date.getHours() + ":" + mins + ")";
        },
        switchSign(amount) {
            return amount * -1;
        },
        splitPayoutRef() {
            console.log("spliting" + this.$props.reference);
            let text = this.$props.reference.slice(0, 22);
            this.reftext = text;
            let date = this.$props.reference.slice(22);
            this.refDate = moment(date).format("DD/MM/YYYY:hh:mm");
        }
    },
};
</script>

